import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';

type TDuration = 1 | 3 | 12;

export const mapOfferDurationToMonths = (
  offer: NonNullable<
    NonNullable<GetFormalOffersResponse['data']>['formal_offers']
  >[number],
): TDuration => {
  if (offer.duration?.unit === 'days') {
    switch (offer.duration.amount) {
      case 30:
        return 1;
      case 91:
        return 3;
      case 365:
        return 12;
    }
  }

  return offer.duration?.amount as TDuration;
};

export const is30DaysOffer = (
  offer: NonNullable<
    NonNullable<GetFormalOffersResponse['data']>['formal_offers']
  >[number],
) => {
  return (
    (offer.duration?.amount === 30 && offer.duration?.unit === 'days') ||
    (offer.duration?.amount === 1 && offer.duration?.unit === 'months')
  );
};
